import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../store";

export type State = {
  groupByPatient: boolean;
  taskListShowActive: boolean;
  showActiveOrRecent: boolean;
};

const userPrefsSlice = createSlice({
  name: "userPrefs",
  initialState: {
    groupByPatient: false,
    taskListShowActive: true,
    showActiveOrRecent: true,
  },
  reducers: {
    setGroupByPatient: (state: State, action: PayloadAction<boolean>) => {
      state.groupByPatient = action.payload;
    },
    setTaskListShowActive: (state: State, action: PayloadAction<boolean>) => {
      state.taskListShowActive = action.payload;
    },
    setShowActiveOrRecent: (state: State, action: PayloadAction<boolean>) => {
      state.showActiveOrRecent = action.payload;
    },
  },
});

export const {
  setGroupByPatient,
  setTaskListShowActive,
  setShowActiveOrRecent,
} = userPrefsSlice.actions;

export default userPrefsSlice.reducer;

export const selectGroupByPatientState = (state: RootState) =>
  state.userPrefs.groupByPatient;
export const selectTaskListShowActiveState = (state: RootState) =>
  state.userPrefs.taskListShowActive;
export const selectShowActiveOrRecentState = (state: RootState) =>
  state.userPrefs.showActiveOrRecent;
